
import School from "./school";

export default function RelocationChild(data) {
	let child = data || {};
	this.birthDate = child.birthDate;
	this.isHandicaped = child.isHandicaped;
	this.isStudent = child.isStudent;
	this.isEmployed = child.isEmployed;
	this.isDependent = child.isDependent;
	this.age = child.age;
	this.name = child.name;

	this.schoolLevel = child.schoolLevel;
	this.school = new School(child.school);
}